module.exports = "<div #cameraEle class=\"ng-camera-feed text-left\" id=\"ng_camera_feed\" style=\"overflow: hidden;width: 250px;height: 200px;\"></div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/camera/camera.component.html
// module id = 542
// module chunks = 2